import { gql, useQuery } from '@apollo/client';
import { fmtNum, fmtRating } from '../lib/format';

const LIST = gql`
  query Products {
    products(order_by: { brand: asc, name: asc }, limit: 200) {
      id ean article_no name brand product_group color size season shop_brand image_url
      stats: product_rating_stat { review_count avg_rating }
    }
  }
`;

type Product = {
  id: string;
  ean: string | null;
  article_no: string | null;
  name: string | null;
  brand: string | null;
  product_group: string | null;
  color: string | null;
  size: string | null;
  season: string | null;
  shop_brand: string | null;
  image_url: string | null;
  stats: { review_count: number | null; avg_rating: number | null } | null;
};

export function ProductsPage() {
  const { data, loading } = useQuery(LIST);
  const products: Product[] = data?.products ?? [];

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h2 className="page-title">Produkte</h2>
          <p className="page-sub">
            {loading ? 'Laden …' : `${fmtNum(products.length)} Produkte im Katalog`}
          </p>
        </div>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <table className="tbl">
          <thead>
            <tr>
              <th></th>
              <th>EAN</th>
              <th>Name</th>
              <th>Marke</th>
              <th>WG</th>
              <th>Farbe</th>
              <th>Größe</th>
              <th>Shop</th>
              <th style={{ textAlign: 'right' }}>Reviews</th>
              <th style={{ textAlign: 'right' }}>Ø</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.id}>
                <td>
                  {p.image_url ? (
                    <img src={p.image_url} width={36} alt="" style={{ borderRadius: 6 }} />
                  ) : null}
                </td>
                <td className="mono" style={{ color: 'var(--fg-3)' }}>{p.ean ?? '—'}</td>
                <td>{p.name ?? '—'}</td>
                <td>{p.brand ?? '—'}</td>
                <td>{p.product_group ?? '—'}</td>
                <td>{p.color ?? '—'}</td>
                <td>{p.size ?? '—'}</td>
                <td>{p.shop_brand ?? '—'}</td>
                <td className="mono" style={{ textAlign: 'right' }}>
                  {fmtNum(p.stats?.review_count ?? 0)}
                </td>
                <td className="mono" style={{ textAlign: 'right' }}>
                  {p.stats?.avg_rating != null ? fmtRating(Number(p.stats.avg_rating)) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
